<div [class]="contentClasses()">
  @if (ctx.prefixIcon; as prefixIcon) {
    <ml-icon [name]="prefixIcon"></ml-icon>
  }

  <div [class]="textWrapperClasses()">
    <div [class]="titleClasses()">
      {{ ctx.title | mlTranslate }}
    </div>
    @if (ctx.description; as desc) {
      <div [class]="subtitleClasses()">
        {{ desc | mlTranslate }}
      </div>
    }
  </div>

  @if (ctx.suffixIcon; as suffixIcon) {
    <ml-icon [name]="suffixIcon" size="sm" (click)="onIconClick(suffixIcon)" [class]="suffixIconClasses()"></ml-icon>
  }

  @if (ctx.variant === 'action' && ctx.actionLabel) {
    <button mlButton size="sm" intent="neutral" (click)="onActionClick()">
      {{ ctx.actionLabel | mlTranslate }}
    </button>
  }
</div>
